import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlipIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flip"}/>
}
